export const VPS_PRICES_CZK = {
  running: {
    vcpu: 52,
    vramGiB: 45,
    diskGiB: 4.5,
  },
  stopped: {
    vcpu: 29.5,
    vramGiB: 30,
    diskGiB: 2,
  },
  publicIpv4First: 38,
  publicIpv4Additional: 44,
} as const;

export type PricingInput = {
  vcpus: number;
  vramGiB: number;
  diskGiB: number;
  publicIpv4: number;
  stopped?: boolean;
};

export function calculateMonthlyPrice(input: PricingInput): number {
  const rates = input.stopped ? VPS_PRICES_CZK.stopped : VPS_PRICES_CZK.running;
  const ipv4 = input.publicIpv4 > 0
    ? VPS_PRICES_CZK.publicIpv4First + ((input.publicIpv4 - 1) * VPS_PRICES_CZK.publicIpv4Additional)
    : 0;
  return (input.vcpus * rates.vcpu)
    + (input.vramGiB * rates.vramGiB)
    + (input.diskGiB * rates.diskGiB)
    + ipv4;
}

export function formatCzk(value: number): string {
  return `${value.toLocaleString("cs-CZ", { minimumFractionDigits: Number.isInteger(value) ? 0 : 1, maximumFractionDigits: 1 })} Kč`;
}

export const PRICE_LIST = [
  { item: "1 vCPU jádro", price: VPS_PRICES_CZK.running.vcpu },
  { item: "1 vCPU jádro, zastavený VPS (SHUTOFF)", price: VPS_PRICES_CZK.stopped.vcpu, stopped: true },
  { item: "1 GiB vRAM (DDR4)", price: VPS_PRICES_CZK.running.vramGiB },
  { item: "1 GiB vRAM (DDR4), zastavený VPS (SHUTOFF)", price: VPS_PRICES_CZK.stopped.vramGiB, stopped: true },
  { item: "1 GiB diskového prostoru (včetně SWAP)", price: VPS_PRICES_CZK.running.diskGiB },
  { item: "1 GiB diskového prostoru, zastavený VPS (SHUTOFF)", price: VPS_PRICES_CZK.stopped.diskGiB, stopped: true },
  { item: "Datový provoz", price: 0 },
  { item: "První veřejná IPv4 adresa ve VPS", price: VPS_PRICES_CZK.publicIpv4First },
  { item: "Druhá a každá další veřejná IPv4 adresa ve VPS", price: VPS_PRICES_CZK.publicIpv4Additional },
  { item: "Privátní IPv4 adresa s podporou NAT", price: 0 },
  { item: "IPv6 adresa", price: 0 },
  { item: "Vzdálená plocha VNC", price: 0 },
  { item: "Neomezené použití HTTP REST API", price: 0 },
  { item: "ISO obrazy instalačních zdrojů", price: 0 },
  { item: "Hardwarová a softwarová anti-DDoS ochrana", price: 0 },
  { item: "Samostatná hardwarová LAN (ens2)", price: 0 },
  { item: "Interní zálohování", price: 0 },
] as const;
